import React, { useState } from 'react';
import GlobalManufacturerLayer from './GlobalManufacturerLayer';
import GlobalGroupLayer from './GlobalGroupLayer';
import GlobalClassLayer from './GlobalClassLayer';
import IndustryLayer from './IndustryLayer';
import TenantsLayer from './TenantsLayer';

const tabs = [
  { key: 'manufacturer', label: 'Manufacturers', Component: GlobalManufacturerLayer },
  { key: 'group', label: 'Groups', Component: GlobalGroupLayer },
  { key: 'class', label: 'Classes', Component: GlobalClassLayer },
  { key: 'industry', label: 'Industry', Component: IndustryLayer },
  { key: 'tenants', label: 'Tenants', Component: TenantsLayer },
];

const GlobalTablesLayer = () => {
  const [activeTab, setActiveTab] = useState(tabs[0].key);
  const ActiveComponent = tabs.find(t => t.key === activeTab).Component;
  return (
    <div className='card h-100 p-0 rounded-0 position-relative overflow-visible'>
      <div className='card-body p-0'>
        <ul className='nav nav-tabs mb-3'>
          {tabs.map(t => (
            <li key={t.key} className='nav-item'>
              <button className={`nav-link ${activeTab === t.key ? 'active' : ''}`} onClick={() => setActiveTab(t.key)}>
                {t.label}
              </button>
            </li>
          ))}
        </ul>
        <ActiveComponent />
      </div>
    </div>
  );
};

export default GlobalTablesLayer;
